<template>
    <div class="flex flex-col gap-3 animate-pulse">
        <div v-for="i in 1" class="flex gap-3 justify-between items-center p-4 rounded-lg border border-[#D0D5DD]">
            <div>
                <div class="w-[147px] h-[11px] rounded-[40px] bg-[#D0D5DD] mb-5"></div>
                <div class="w-[34px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
            </div>
            <div class="w-[34px] h-[11px] rounded-[40px] bg-[#D0D5DD]"></div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>